import { supabase } from '@/core/infrastructure/supabase/supabaseClient';

export interface WaitlistPayload {
  user_id: string; // From auth.users()
  nombre_completo: string;
  email: string;
  especialidad_principal: string;
  cedula_identidad: string;
  colegio_estado: string; // "Colegio al que está afiliado / Estado"
  registro_mpps: string;
}

export class WaitlistService {
  /**
   * Envía la solicitud de waitlist a Supabase
   */
  static async joinWaitlist(payload: WaitlistPayload): Promise<boolean> {
    const { error } = await supabase
      .from('waitlist_clinicos')
      .insert([
        {
          user_id: payload.user_id,
          nombre_completo: payload.nombre_completo,
          email: payload.email,
          especialidad_principal: payload.especialidad_principal,
          cedula_identidad: payload.cedula_identidad,
          colegio_estado: payload.colegio_estado,
          registro_mpps: payload.registro_mpps,
        }
      ]);

    if (error) {
      if (error.code === '23505') { // Postgres Unique Violation
        throw new Error('Ya existe una solicitud registrada con esta Cédula o Correo.');
      }
      throw new Error(error.message || 'Error al enviar la solicitud.');
    }

    return true;
  }

  /**
   * Verifica si el usuario actual (por su UUID) ya está en la lista de espera
   */
  static async checkHasSubmittedWaitlist(userId: string): Promise<boolean> {
    if (!userId) return false;

    const { data, error } = await supabase
      .from('waitlist_clinicos')
      .select('id')
      .eq('user_id', userId)
      .limit(1)
      .single();

    if (error && error.code !== 'PGRST116') {
      // Ignore not found error
      console.error('[WaitlistService] Error checking waitlist status:', error.message);
    }

    return !!data;
  }
}
